var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemSchoolIconColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.55 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#add8e6;fill-rule:evenodd;}"))), /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Social"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_-Round-_-Social-_-school",
    "data-name": "-Round-/-Social-/-school"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_-Icon-Color",
    "data-name": "\\uD83D\\uDD39-Icon-Color",
    className: "cls-1",
    d: "M4.67,15.89V20.4a3.22,3.22,0,0,0,1.67,2.82l8,4.38a3.18,3.18,0,0,0,3.08,0l8-4.38a3.22,3.22,0,0,0,1.67-2.82V15.89l-9.69,5.29a3.18,3.18,0,0,1-3.08,0ZM14.36.39.83,7.77a1.61,1.61,0,0,0,0,2.82L14.36,18a3.18,3.18,0,0,0,3.08,0l12.9-7v9.48a1.61,1.61,0,1,0,3.21,0V10.13a1.62,1.62,0,0,0-.83-1.42L17.44.39A3.24,3.24,0,0,0,14.36.39Z",
    style: {
      fill: "rgb(209, 25, 197)"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemSchoolIconColored);
export default __webpack_public_path__ + "static/media/item_school_icon_colored.8fe37e6c299b24701d9388a70391c63a.svg";
export { ForwardRef as ReactComponent };